"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterDeleteStandbyActivity = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const FooterDeleteStandbyActivity = ({ details, deleteLiveShift, close, disabled }) => {
    if (!details)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(_ui_1.Button, { color: _ui_1.Button.COLORS.RED, label: (0, i18n_1.t)('VIEW_SHIFT_DEL_ACTIVITY'), onClick: () => {
                deleteLiveShift(details.id).then(() => {
                    close();
                    // reload the employee calendar
                    if (window.reloadEmployeeCalendar) {
                        setTimeout(() => {
                            window.reloadEmployeeCalendar?.();
                        }, 500);
                    }
                }).catch(() => { });
            }, disabled: disabled }),
        react_1.default.createElement(_ui_1.Button, { label: (0, i18n_1.t)('CLOSE'), onClick: () => close() })));
};
exports.FooterDeleteStandbyActivity = FooterDeleteStandbyActivity;
